var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 17,
    viewBox: "0 0 23 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5383 0.00976562V2.45174H0V0.00976562H14.5383ZM14.5383 4.83693V7.2789H0V4.83693H14.5383ZM0 12.1061V9.72088H9.71111V12.1061H0ZM16.9802 0.00976562H23V2.45174H19.3654V13.3554C19.3654 14.3398 19.0152 15.1917 18.3148 15.911C17.6144 16.6303 16.7626 16.99 15.7593 16.99C14.756 16.99 13.8947 16.6303 13.1753 15.911C12.456 15.1917 12.0963 14.3303 12.0963 13.3271C12.0963 12.3238 12.456 11.4719 13.1753 10.7715C13.8947 10.0711 14.7465 9.72088 15.7309 9.72088C16.1473 9.72088 16.5638 9.7966 16.9802 9.94804V0.00976562Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrack);
export default __webpack_public_path__ + "static/media/track.f73d2b67d977e5feb0a293e2703a6234.svg";
export { ForwardRef as ReactComponent };